import React, { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { useAuth } from '../../contexts/AuthContext';
import { exportCameraUploads } from '../../api/cameraUpload';

interface ExportButtonProps {
  deviceId: string;
  deviceName: string;
  disabled?: boolean;
}

const ExportButton: React.FC<ExportButtonProps> = ({ deviceId, deviceName, disabled }) => {
  const auth = useAuth();
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    setExporting(true);
    try {
      const blob = await exportCameraUploads(deviceId, auth.tokens?.accessToken ?? '');
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${deviceName}-sorted.zip`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } finally {
      setExporting(false);
    }
  };

  return (
    <Button
      variant="outlined"
      startIcon={exporting ? <CircularProgress size={16} /> : <DownloadIcon />}
      onClick={handleExport}
      disabled={disabled || exporting}
    >
      Export sorted zip
    </Button>
  );
};

export default ExportButton;
